import React from 'react';

import { ThemeProvider } from '@emotion/react';
import {reBrandTheme} from "./rebrand";
import {defaultTheme} from "./defaultTheme";

interface IThemeProps {
    isNewBrand: boolean;
    children: React.ReactNode;
}

export const Theme = (props: IThemeProps) => {
    const {isNewBrand} = props;
    const currentTheme = isNewBrand ? reBrandTheme : defaultTheme;
    return <ThemeProvider theme={currentTheme}>
        {props.children}
    </ThemeProvider>;
};
